import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-collection-langs',
  templateUrl: './collection-langs.component.html',
  styleUrls: ['./collection-langs.component.css']
})
export class CollectionLangsComponent implements OnInit {
    collectionKeyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.collectionKeyno = this.stateService.getStateParams()['collection_keyno'];
    }

    private async loadLanguages() {
        if (!this.collectionKeyno) return;

        this.inputListLanguages = await this.datatask.Post(1222, { collection_keyno: this.collectionKeyno });
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(1223, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    collection_keyno: string;
    collectionlang_name: string;
    language_id: string;
    language_name: string;
    orderby: string;
}
